import { forwardRef, type HTMLAttributes, type CSSProperties } from 'react'

import '@app/components/page-wrapper.scss'
import { VirtualPage } from '@app/components/virtual-page'

type PageWrapperProps = HTMLAttributes<HTMLDivElement> & {
  pageIndex: number
  goToPage: (index: number) => void
}

export const PageWrapper = forwardRef<HTMLElement, PageWrapperProps>((props, ref) => {
  const { pageIndex, children, goToPage, ...rest } = props
  const mainClass = `page-${pageIndex || 1}`

  const reactNodeChildren = Array.isArray(children) ? children : [children]

  const first2Pages = reactNodeChildren.slice(0, 2)
  const restOfChildren = reactNodeChildren.slice(2)

  return (
    <>
      <main ref={ref} className={mainClass} {...rest}>
        <VirtualPage index={pageIndex} isActive={pageIndex < 2}>
          {first2Pages}
        </VirtualPage>

        {restOfChildren.map((child, idx) => (
          <VirtualPage key={idx} index={idx} pageIndex={idx + 2} isActive={pageIndex === idx + 2}>
            {child}
          </VirtualPage>
        ))}
      </main>

      <div
        className="page-indicator"
        style={{ '--active-page': pageIndex, '--number-of-pages': reactNodeChildren.length } as CSSProperties}
      >
        <div className="page-indicator__slider" />
        <div className="page-indicator__dots">
          {reactNodeChildren.map((_, idx) => (
            <div key={idx} className="page-indicator__dot" onClick={() => goToPage(idx)} />
          ))}
        </div>
      </div>
    </>
  )
})

PageWrapper.displayName = 'PageWrapper'
